import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import "core-js/stable";
import "core-js/features/string/repeat";
import "core-js/es/number";
import "core-js/es/array";
import "@babel/polyfill";
import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./styles.css";
import { BrowserRouter as Router } from "react-router-dom";
import Auth0ProviderWithHistory from "./auth/auth0-provider-with-history";

ReactDOM.render(
  // <React.StrictMode>
  //   <App className="App" />
  // </React.StrictMode>,
  <Router>
    <Auth0ProviderWithHistory>
      <App className="App" />
    </Auth0ProviderWithHistory>
  </Router>,

  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
